<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
        <path d="M15.924,4C14.414,4.011,12.982,4.676,12,5.822C11.018,4.677,9.589,4.013,8.081,4c-2.623-0.028-4.772,2.075-4.8,4.697
     c0,0.034,0,0.068,0,0.103c0,3.3,2.965,5.981,7.455,10.062L12,20l1.264-1.151c4.49-4.072,7.455-6.757,7.455-10.053
     C20.745,6.173,18.64,4.026,16.017,4C15.986,4,15.955,4,15.924,4z M12.088,17.559l-0.087,0.087l-0.087-0.087
     C7.763,13.8,5.025,11.316,5.025,8.8C4.982,7.155,6.281,5.787,7.927,5.744c0.051-0.001,0.103-0.001,0.154,0
     c1.352,0.008,2.571,0.815,3.108,2.056h1.631c0.53-1.243,1.749-2.052,3.1-2.058c1.645-0.043,3.013,1.257,3.056,2.902
     c0.001,0.052,0.001,0.104,0,0.156C18.976,11.316,16.237,13.8,12.088,17.559z" />
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'heart'
}
</script>
